namespace $.$$ {

	$mol_style_define( $shm_check_list_only, {

		Check: {
			align: { items: 'center' },
			gap: $mol_gap.text,
			minWidth: 0,
		},

		Toggle: {
			flex: { grow: 1, shrink: 1 },
			minWidth: 0,
		},

		Only: {
			flex: { grow: 0, shrink: 0 },
			font: { size: '.75rem' },
			padding: $mol_gap.text,
		},

		'@': {
			shm_check_list_only_inline: {
				'true': {
					flex: { direction: 'row', wrap: 'wrap' },
					align: { items: 'center' },
					gap: $mol_gap.text,

					All: {
						flex: { grow: 0, shrink: 0 },
					},

					Checks: {
						flex: { direction: 'row', wrap: 'wrap' },
						align: { items: 'center' },
						gap: $mol_gap.text,
					},
				},
			},
		},

	} )

}
